import OnEvent from "../decorators/on-event"
import QuerySelector from "../decorators/query-selector"
import ListService from "../services/list-service"
import HotlistStorage from "../decorators/hotlist-storage"
import SavedState from "./saved-state"
import Singleton from "../decorators/singleton"
import FixedTabs from "./fixed-tabs"
import ErrorHandlers from "./error-handlers"
import TrackingService from "../services/tracking-service"

export default class EditList {

    @HotlistStorage
    private hotlistStorage: any

    @QuerySelector('[list-name]')
    private listName: HTMLInputElement

    @QuerySelector('[save-hl-name]')
    private hlNameSave: HTMLDivElement

    @Singleton
    private fixedTabs: FixedTabs

    @Singleton
    private errorHandler: ErrorHandlers

    public updateListName(name: string): void {
        this.listName.value = name
        this.listName.dispatchEvent(new CustomEvent('change'))
        this.hotlistStorage.name = name

        this.fixedTabs.updateFixedTabs()
    }

    private validRenameList(): void {
        ListService.renameList(this.listName.value)
            .then(name => {
                TrackingService.trackEvent('RENAMED_WISHLIST', [{
                    old: this.hotlistStorage.name,
                    new: name
                }])
                this.updateListName(name)
                SavedState.nameSaved()
            })
            .catch(() => this.errorHandler.renameListErrorState())
    }

    private checkValid(): boolean {
        return this.listName.checkValidity() && this.listName.value !== this.hotlistStorage.name
    }

    @OnEvent({
        selector: '[list-name]',
        eventNames: ['blur', 'keyup']
    })
    public renameList(event: any): void {
        if (event.type === 'blur') {
            if (this.checkValid()) this.validRenameList()
            else this.updateListName(this.hotlistStorage.name)
        }

        if (event.keyCode === 13) {
            if (this.checkValid()) this.hlNameSave.focus()
            else if (this.listName.checkValidity()) this.hlNameSave.focus()
        }
    }
}